export default "__VITE_ASSET__mFEY6$pI__"